var map = {
	"./Logo_TecNM_Horizontal.svg": "3a74",
	"./Logo_TecNM_Horizontal_Blanco.svg": "c0a0",
	"./Logo_TecNM_Vertical.svg": "f3ff",
	"./Logo_TecNM_Vertical_Blanco.svg": "5ad5",
	"./Logo_TecNM_Vertical_Blanco_Sin_Letras.svg": "cc19",
	"./adeudos.svg": "1e94",
	"./alumnos.svg": "e092",
	"./aulas.svg": "59cd",
	"./carreracoordinador.svg": "8c6f",
	"./carreras.svg": "54ee",
	"./edificios.svg": "f345",
	"./esp.svg": "e96e",
	"./especialidad.svg": "77f2",
	"./especialidades.svg": "2bb5",
	"./grupos.svg": "17c1",
	"./kardex.svg": "5beb",
	"./logo.png": "9d64",
	"./logo_chico.png": "77d7",
	"./logo_grande.png": "037e",
	"./materias.svg": "7f7e",
	"./ordendeacceso.svg": "687c",
	"./periodos.svg": "f13c",
	"./personal.svg": "bbf0",
	"./planes.svg": "fbad",
	"./planteles.svg": "576f",
	"./reticulas.svg": "d98b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";